module.exports = __webpack_public_path__ + "images/hamburger.svg";